// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { RadioGroup, Input } from '@/components/ui'
import type { OnboardingData } from '@/types'

const HAS_CHILDREN_OPTIONS = [
  { value: 'yes', label: 'Ja, ik heb kinderen' },
  { value: 'no',  label: 'Nee, ik heb geen kinderen' },
]

interface Step7ChildrenProps {
  data:     Partial<OnboardingData>
  onChange: (updates: Partial<OnboardingData>) => void
  errors:   Partial<Record<keyof OnboardingData, string>>
}

export function Step7Children({ data, onChange, errors }: Step7ChildrenProps) {
  const hasChildren = data.hasChildren ?? false

  return (
    <div className="flex flex-col gap-5">
      <div>
        <h2 className="text-lg font-semibold text-ink mb-1">Kinderen</h2>
        <p className="text-sm text-ink-3">
          Dit helpt bij het invullen van secties over uw nabestaanden en erfopvolging.
        </p>
      </div>

      <RadioGroup
        name="hasChildren"
        options={HAS_CHILDREN_OPTIONS}
        value={hasChildren ? 'yes' : 'no'}
        onChange={(v) => onChange({ hasChildren: v === 'yes', numberOfChildren: v === 'yes' ? (data.numberOfChildren || 1) : 0 })}
      />

      {hasChildren && (
        <div className="animate-slide-down">
          <Input
            label="Aantal kinderen"
            type="number"
            value={data.numberOfChildren?.toString() ?? '1'}
            onChange={(e) => onChange({ numberOfChildren: parseInt(e.target.value) || 0 })}
            error={errors.numberOfChildren}
            min={1}
            max={20}
            hint="Minderjarige en meerderjarige kinderen samen"
          />
        </div>
      )}

      <p className="text-xs text-ink-4 bg-sand px-3.5 py-3 rounded-xl">
        U kunt later in de app meer details invullen over uw kinderen en hun contactgegevens.
      </p>
    </div>
  )
}
